module.exports = __webpack_public_path__ + "img/y-163.7cbac011.png";